import React from "react";
import Swiper from "react-id-swiper";

class CovidVaxMap extends React.Component {
  render() {
    const params = {
      effect: "coverflow",
      grabCursor: true,
      initialSlide: 0,
      centeredSlides: true,
      loop: true,
      spaceBetween: 0,
      slidesPerView: 3,
      pagination: {},
      coverflowEffect: {
        rotate: 0,
        stretch: 0,
        depth: 100,
        modifier: 1.43,
        slideShadows: false
      },
      autoplay: {
        delay: 5000
      },
      breakpoints: {
        360: {
          slidesPerView: 1,
          coverflowEffect: {
            depth: 50,
            modifier: 0
          }
        },
        640: {
          slidesPerView: 3,
          coverflowEffect: {
            depth: 80,
            modifier: 0
          }
        }
      }
    };

    return (
      <section id="covidvaxmap" className="theme-bg-covidvaxmap screenshots">
        <div className="container">
          <div className="row">
            <div className="col-md-12 text-center">
              <div className="section-title">
                <h2>
                  <a 
                    href="https://covidvaxmap.com"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    <img
                      className="covidvaxmap-logo"
                      src="https://cdn.johnbernazzani.com/covidvaxmap_logo.png"
                      alt="1"
                    />
                  </a>
                </h2>
                <p className="text-white">(personal)</p>
                <img
                  src="https://cdn.johnbernazzani.com/white-line.svg"
                  alt="title-line"
                  className="img-fluid title-line"
                />
              </div>
            </div>
          </div>
          <div className="row">
            <div className="col-sm-12">
              <img
                src="https://cdn.johnbernazzani.com/mockups/covidvaxmap/covid_screenshot_1.png"
                className="img-fluid"
                alt="1"
              />
            </div>
            <div className="col-sm-12 mt-3">
              <img
                src="https://cdn.johnbernazzani.com/mockups/covidvaxmap/covid_screenshot_2.png"
                className="img-fluid"
                alt="1"
              />
            </div>
            <div className="col-sm-12 mt-3">
              <img
                src="https://cdn.johnbernazzani.com/mockups/covidvaxmap/covid_screenshot_3.png"
                className="img-fluid"
                alt="1"
              />
            </div>
          </div>
          <div className="row m-0">
            <div className="col-12 text-center app-description">
              <h1>
                <i className="fa fa-desktop" />
              </h1>
              <p>
                A web app built to simplify the vaccine appointment process. Has helped 100k+ people in 40+ states find nearby vaccine appointments through real-time text and email alerts the minute pharmacy slots become available.
              </p>
              <a
                href="https://covidvaxmap.com"
                target="_blank"
                rel="noopener noreferrer"
              >
                <button className="btn btn-primary">Learn More</button>
              </a>
            </div>
          </div>
          <div className="row crafted-with">
            <div className="col-12 text-center">
              <p>Crafted with</p>
            </div>
          </div>
          <div className="row tech-stack d-flex flex-row justify-content-center">
            <div className="tech-card d-flex align-items-center">
              <img src="https://cdn.johnbernazzani.com/react.png" alt="1" />
            </div>
            <div className="tech-card d-flex align-items-center">
              <img src="https://cdn.johnbernazzani.com/bootstrap.png" alt="1" />
            </div>
            <div className="tech-card d-flex align-items-center">
              <img src="https://cdn.johnbernazzani.com/node.png" alt="1" />
            </div>
            <div className="tech-card d-flex align-items-center">
              <img src="https://cdn.johnbernazzani.com/postgresql.png" alt="1" />
            </div>
            <div className="tech-card d-flex align-items-center">
              <img src="https://cdn.johnbernazzani.com/aws.png" alt="1" />
            </div>
          </div>
        </div>
      </section>
    );
  }
}

export default CovidVaxMap;



// WEBPACK FOOTER //
// ./src/components/covidvaxmap.js